import { useCallback, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../Infrastructure/store';
import { DEFAULT_DOCUMENT_TITLE, setPageTitle } from '../Infrastructure/applicationSlice';

function usePageTitle() {
	const appDispatch = useAppDispatch();
	const { pageTitle, selectedTerminal } = useAppSelector((state) => state.applicationState);

	useEffect(() => {
		document.title = pageTitle;
	}, [pageTitle]);

	/**
	 * Method used to unify the site document title. Consuming pages can pass in their designated title
	 * and it will be concatonated to the prefixed titles.
	 */
	const addPageTitle = useCallback(
		(pageTitle: string) => {
			let newPageTitle = DEFAULT_DOCUMENT_TITLE;

			// Once we are into a site, replace Dispatch Portal
			if (selectedTerminal) {
				newPageTitle = selectedTerminal.number;
			}

			if (pageTitle) {
				newPageTitle = `${newPageTitle} - ${pageTitle}`;
			}

			appDispatch(setPageTitle(newPageTitle));
		},
		[appDispatch, selectedTerminal]
	);

	return { addPageTitle };
}

export default usePageTitle;
